export default {
      id: "none-img-usage",
      viewBox: "0 0 594 594",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#none-img",
      toString: function () {
        return this.url;
      }
    }